import * as RadixDialog from "@radix-ui/react-dialog";
import { Menu as MenuIcon, PanelsTopLeft } from "lucide-react";
import { useState } from "react";
import { Outlet } from "react-router";

import { useStaff } from "@/auth/AuthProvider";
import { Sidebar } from "@/shell/Sidebar";
import { readCollapsed, saveCollapsed } from "@/shell/sidebarState";
import { Button } from "@/ui/Button";

/**
 * The platform console's frame, for Darkstar staff (ADR-0015): the same sidebar as an
 * organization's pages, with the console's own navigation. Below `md` it is a drawer.
 */
export function PlatformShell() {
  const staff = useStaff();
  const [collapsed, setCollapsed] = useState(readCollapsed);
  const [drawer, setDrawer] = useState(false);

  const toggle = () => {
    saveCollapsed(!collapsed);
    setCollapsed(!collapsed);
  };

  return (
    <div className="flex h-dvh bg-bg">
      <aside className="hidden h-full shrink-0 md:block" aria-label="Sidebar">
        <Sidebar me={staff} collapsed={collapsed} onToggle={toggle} />
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex h-12 shrink-0 items-center gap-2 border-b border-line bg-surface px-3 md:hidden">
          <RadixDialog.Root open={drawer} onOpenChange={setDrawer}>
            <RadixDialog.Trigger asChild>
              <Button variant="ghost" size="sm" className="w-8 px-0" aria-label="Open the menu">
                <MenuIcon aria-hidden="true" />
              </Button>
            </RadixDialog.Trigger>
            <RadixDialog.Portal>
              <RadixDialog.Overlay className="fixed inset-0 z-50 bg-black/40" />
              <RadixDialog.Content
                aria-describedby={undefined}
                className="fixed inset-y-0 left-0 z-50 focus:outline-none"
              >
                <RadixDialog.Title className="sr-only">Menu</RadixDialog.Title>
                <Sidebar me={staff} collapsed={false} onNavigate={() => setDrawer(false)} />
              </RadixDialog.Content>
            </RadixDialog.Portal>
          </RadixDialog.Root>
          <span
            aria-hidden="true"
            className="grid size-7 place-items-center rounded-md bg-accent text-accent-ink"
          >
            <PanelsTopLeft className="size-4" />
          </span>
          <span className="truncate text-sm font-semibold text-ink">Darkstar platform</span>
        </div>
        <div className="min-h-0 flex-1 overflow-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
